/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/sap-abap/SapAbapOutboundConfigEditDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SapAbapOutboundConfigEditDialogTestIds = {
  btnCancelSapAbapConfig: "btn-cancel-sap-abap-config",
  btnSaveSapAbapConfig: "btn-save-sap-abap-config",
  sapAbapCompositeRoleExpansionSelect: "sap-abap-composite-role-expansion-select",
  sapAbapPasswordPolicySelect: "sap-abap-password-policy-select",
  sapAbapRoleAssignmentModeSelect: "sap-abap-role-assignment-mode-select",
  selectSapAbapAuthType: "select-sap-abap-auth-type",
  selectSapAbapUserType: "select-sap-abap-user-type"
} as const;
